import React from "react";
import Routing from "./routes";
import { ConfigProvider } from "antd";
// import withSplashScreen from "./components/SplashScreen/withSplashScreen";
import { LanguageProvider } from "./context/LanguageContext";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./pages/error/ErrorBoundary";
import { AuthProvider } from "./components/msalAuth/AuthProvider";
// import { useAllTabsMonitor } from "./components/idle/allTabsMonitor";

const App = () => {
  // useAllTabsMonitor();
  const antDesignConfig = {
    components: {
      Modal: {
        zIndexPopup: 1100,
      },
      Notification: {
        zIndexPopup: 1090,
      },
    },
  };

  return (
    <ConfigProvider theme={antDesignConfig}>
      <ErrorBoundary>
        <AuthProvider>
          <LanguageProvider>
            <BrowserRouter>
              <div className="App">
                <Routing />
              </div>
            </BrowserRouter>
          </LanguageProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ConfigProvider>
  );
};

export default App;
